import React from "react";
import { BottomTabs } from "./BottomTabs";

interface AnalysisLayoutProps {
  children: React.ReactNode;
}

/**
 * Layout wrapper for analysis page that provides bottom navigation.
 * This is used for routes outside the /mvp nested structure that still need MVP navigation.
 */
export function AnalysisLayout({ children }: AnalysisLayoutProps) {
  return (
    <div className="min-h-screen pb-20">
      {children}
      <BottomTabs />
    </div>
  );
}


